module.exports = __webpack_public_path__ + "img/work_parked.11ba3251.svg";